// Build-time stub for netDebugLog (APL-11850). Non-debug builds (VITE_MODE
// outside development/staging) alias '@/lib/netDebugLog' HERE at bundle time
// (vite.config.ts, command === 'build' only) so the real capture machinery —
// fetch/XHR/axios patching, the ring buffer, redaction — never enters the
// production/demo bundle at all. The runtime gate inside the real
// initNetDebug stays as defense in depth; this makes the exclusion a
// build-shape guarantee instead of a minifier outcome.
//
// Surface parity with the real module is pinned by netDebugLog.stub.test.ts —
// add an export there and here when the real module grows one. Types are
// re-exported from the real module (type-only → erased at build, so the real
// module still never lands in the bundle).
import type { NetDebugSnapshot } from './netDebugLog';

export type { NetDebugEntry, NetDebugSnapshot, NetDebugState } from './netDebugLog';

const EMPTY_SNAPSHOT: NetDebugSnapshot = { entries: [], pendingCount: 0, failedCount: 0 };

export const isLongLivedNetDebugUrl = (_url: string): boolean => false;

export const sanitizeNetDebugUrl = (raw: unknown): string => String(raw ?? '');

export const initNetDebug = (_options: { isIosApp: boolean; axiosInstance?: unknown }): boolean =>
  false;

export const isNetDebugEnabled = (): boolean => false;

export const subscribeNetDebug =
  (_listener: () => void): (() => void) =>
  () =>
    undefined;

export const getNetDebugSnapshot = (): NetDebugSnapshot => EMPTY_SNAPSHOT;

export const clearNetDebug = (): void => undefined;

export const __resetNetDebugForTests = (): void => undefined;
